import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'prima-nota';
export const ENTITY_PLURAL = 'Registrazione Prima Nota';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Codice Tipologia',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'tipologia.codice',
    initialHideColumn: true,
    hideFilter: true,
    exportHideColumn: false,
  },
  {
    elementLabel: 'N. Reg.',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'nrReg',
    minWidth: 120,
    maxWidth: 120,
  },
  {
    elementLabel: 'Data',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataRegistrazione',
    minWidth: 100,
  },
  {
    elementLabel: 'Cod. Piano Finanziario',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoFinanziario.codice',
  },
  {
    elementLabel: 'Note',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'note',
  },
  {
    elementLabel: 'Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'totaleRigheDare',
    contentAlignment: ContentAlignmentEnum.Right,
    sortable: false,
    hideFilter: true,
  },
  {
    elementLabel: 'Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'totaleRigheAvere',
    contentAlignment: ContentAlignmentEnum.Right,
    sortable: false,
    hideFilter: true,
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
